export class TreeNode {
	title: string;
	type: string;
	id: string;
	children: TreeNode[];
	properties: any;

	constructor() {
		this.children = new Array<TreeNode>();
	}
}
